import { Input, Select, Button, Card, Row, Col } from "antd";
const { Option } = Select;

const estadosOptions = [
  { value: "", label: "Todos los estados" },
  { value: "1", label: "Pendiente" },
  { value: "2", label: "Procesado con éxito" },
  { value: "3", label: "Duplicado" },
  { value: "4", label: "Documento validado" },
  { value: "5", label: "Documento no encontrado" },
  { value: "0", label: "Error" },
];

export function FiltrosLista({
  filtroEstado,
  filtroTexto,
  onFiltroEstadoChange,
  onFiltroTextoChange,
  onLimpiarFiltros,
}) {
  return (
    <Card variant="outlined" style={{ borderRadius: 8, padding: 10 }}>
      <Row gutter={[16, 16]}>
        <Col xs={24} md={8}>
          <label style={{ fontSize: 12, fontWeight: 500 }}>Estado</label>
          <Select
            value={filtroEstado}
            onChange={onFiltroEstadoChange}
            placeholder="Seleccionar estado"
            style={{ width: "100%" }}
          >
            {estadosOptions.map((estado) => (
              <Option key={estado.value} value={estado.value}>
                {estado.label}
              </Option>
            ))}
          </Select>
        </Col>
        <Col xs={24} md={10}>
          <label style={{ fontSize: 12, fontWeight: 500 }}>
            Nombre del soporte o Código único
          </label>
          <Input
            placeholder="Buscar por nombre o código..."
            value={filtroTexto}
            onChange={(e) => onFiltroTextoChange(e.target.value)}
          />
        </Col>
        <Col xs={24} md={6} style={{ display: "flex", alignItems: "end" }}>
          <Button onClick={onLimpiarFiltros}>Limpiar filtros</Button>
        </Col>
      </Row>
    </Card>
  );
}
